import { render, staticRenderFns } from "./MsgElementText_Face.vue?vue&type=template&id=1635068c&scoped=true"
import script from "./MsgElementText_Face.vue?vue&type=script&lang=js"
export * from "./MsgElementText_Face.vue?vue&type=script&lang=js"
import style0 from "./MsgElementText_Face.vue?vue&type=style&index=0&id=1635068c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1635068c",
  null
  
)

export default component.exports